const b2bHeader = document.querySelector('[data-b2b-sticky-header]');
const b2bWhatsAppCurrentPhone = '8618033198854';
const b2bWhatsAppLegacyPhones = ['8613902248721'];

document.querySelectorAll('a[href*="wa.me/"]').forEach((link) => {
  const href = link.getAttribute('href');
  if (!href) return;

  const updatedHref = b2bWhatsAppLegacyPhones.reduce(
    (nextHref, legacyPhone) => nextHref.replace(legacyPhone, b2bWhatsAppCurrentPhone),
    href
  );

  if (updatedHref !== href) {
    link.setAttribute('href', updatedHref);
  }
});

if (b2bHeader) {
  const setHeaderOffset = () => {
    const headerHeight = Math.ceil(b2bHeader.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--b2b-header-height', `${headerHeight}px`);
    document.body.style.setProperty('--b2b-header-height', `${headerHeight}px`);
  };

  const updateHeaderShadow = () => {
    b2bHeader.classList.toggle('is-scrolled', window.scrollY > 8);
  };

  setHeaderOffset();
  updateHeaderShadow();
  window.addEventListener('resize', setHeaderOffset);
  window.addEventListener('scroll', updateHeaderShadow, { passive: true });

  if ('ResizeObserver' in window) {
    new ResizeObserver(setHeaderOffset).observe(b2bHeader);
  }

  b2bHeader.querySelectorAll('.b2b-site-header__mobile-panel a').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = link.closest('details');
      if (menu) menu.open = false;
    });
  });
}

const b2bLanguageForm = document.getElementById('B2BHeaderLanguageForm');
const b2bLanguageStorageKey = 'b2bPreferredLanguage';

const normalizeB2BLanguageCode = (languageCode) => {
  if (!languageCode) return 'en';
  return languageCode.toLowerCase().startsWith('zh') ? 'zh-CN' : 'en';
};

const getStoredB2BLanguage = () => {
  try {
    const storedLanguage = window.localStorage.getItem(b2bLanguageStorageKey);
    return storedLanguage ? normalizeB2BLanguageCode(storedLanguage) : '';
  } catch (error) {
    return '';
  }
};

const setStoredB2BLanguage = (languageCode) => {
  try {
    window.localStorage.setItem(b2bLanguageStorageKey, normalizeB2BLanguageCode(languageCode));
  } catch (error) {
    // Some browsers block localStorage in private or restricted contexts.
  }
};

const getCurrentB2BLanguage = () => normalizeB2BLanguageCode(document.documentElement.lang);

const getB2BLocalizedPath = (languageCode, path) => {
  const normalizedLanguage = normalizeB2BLanguageCode(languageCode);
  const currentPath = path || '/';
  const withoutLanguagePrefix = currentPath === '/zh' ? '/' : currentPath.replace(/^\/zh(?=\/)/, '');

  if (normalizedLanguage === 'zh-CN') {
    if (currentPath === '/zh' || currentPath.startsWith('/zh/')) return currentPath;
    if (currentPath === '/') return '/zh';
    return `/zh${currentPath}`;
  }

  return withoutLanguagePrefix;
};

const localizeB2BInternalUrl = (href, languageCode) => {
  if (!href || href.startsWith('#')) return href;
  if (/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return href;

  let url;
  try {
    url = new URL(href, window.location.origin);
  } catch (error) {
    return href;
  }

  if (url.origin !== window.location.origin) return href;
  if (url.pathname === '/localization') return href;
  if (url.pathname.startsWith('/cdn/')) return href;
  if (url.pathname.startsWith('/checkout')) return href;

  url.pathname = getB2BLocalizedPath(languageCode, url.pathname);
  return `${url.pathname}${url.search}${url.hash}`;
};

const keepB2BLanguageOnInternalLinks = (languageCode) => {
  document.querySelectorAll('a[href]').forEach((link) => {
    link.setAttribute('href', localizeB2BInternalUrl(link.getAttribute('href'), languageCode));
  });
};

const applyStoredB2BLanguage = () => {
  const storedLanguage = getStoredB2BLanguage();
  const activeLanguage = storedLanguage || getCurrentB2BLanguage();
  const localizedPath = getB2BLocalizedPath(activeLanguage, window.location.pathname);

  if (storedLanguage && localizedPath !== window.location.pathname) {
    window.location.replace(`${localizedPath}${window.location.search}${window.location.hash}`);
    return false;
  }

  keepB2BLanguageOnInternalLinks(activeLanguage);
  return true;
};

const b2bLanguageReady = applyStoredB2BLanguage();

if (b2bLanguageReady && b2bLanguageForm) {
  const languageInput = b2bLanguageForm.querySelector('input[name="language_code"]');
  const languageButtons = b2bLanguageForm.querySelectorAll('[data-b2b-language-option]');

  if (languageInput) {
    languageButtons.forEach((button) => {
      button.addEventListener('click', () => {
        languageInput.value = button.dataset.b2bLanguageOption;
        setStoredB2BLanguage(button.dataset.b2bLanguageOption);
        b2bLanguageForm.submit();
      });
    });
  }
}

const initB2BCatalogueInlineSearch = () => {
  const getResultsContainer = (scope) => {
    const existingResults = scope.querySelector('[data-b2b-catalogue-results]');
    if (existingResults) return existingResults;

    const grid = scope.querySelector('.b2b-catalogue-product-grid');
    const emptyState = scope.querySelector('.b2b-empty');
    const firstResultNode = grid || emptyState;
    if (!firstResultNode) return null;

    const results = document.createElement('div');
    results.className = 'b2b-catalogue-results';
    results.setAttribute('data-b2b-catalogue-results', '');
    firstResultNode.parentNode.insertBefore(results, firstResultNode);
    results.appendChild(firstResultNode);

    const pagination = scope.querySelector('.b2b-catalogue-pagination');
    if (pagination) results.appendChild(pagination);

    return results;
  };

  const getStatusNode = (scope, form) => {
    const existingStatus = scope.querySelector('[data-b2b-catalogue-search-status]');
    if (existingStatus) return existingStatus;

    const status = document.createElement('div');
    status.className = 'visually-hidden';
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('data-b2b-catalogue-search-status', '');
    const toolbar = form.closest('.b2b-catalogue-toolbar');
    (toolbar || form).after(status);
    return status;
  };

  document.querySelectorAll('[data-b2b-catalogue-search-form], .b2b-catalogue-main .b2b-catalogue-toolbar__search').forEach((form) => {
    const scope = form.closest('[data-b2b-catalogue-search-scope]') || form.closest('.b2b-catalogue-main');
    const results = scope ? getResultsContainer(scope) : null;
    const status = scope ? getStatusNode(scope, form) : null;
    const input = form.querySelector('input[name="q"]');

    if (!scope || !results || !input) return;

    const originalResults = results.innerHTML;
    const loadingText = form.dataset.loadingText || 'Loading search results';
    const errorText = form.dataset.errorText || 'Search could not be loaded. Please try again.';
    let searchController = null;
    let searchTimer = null;

    const setStatus = (message) => {
      if (status) status.textContent = message || '';
    };

    const setLoading = (isLoading) => {
      results.classList.toggle('is-loading', isLoading);
      results.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    };

    const restoreCatalogue = () => {
      if (searchController) searchController.abort();
      results.innerHTML = originalResults;
      setStatus('');
      setLoading(false);
    };

    const getSearchUrl = (sourceUrl) => {
      const url = new URL(sourceUrl || form.getAttribute('action'), window.location.origin);
      url.searchParams.set('q', input.value.trim());
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      return url.toString();
    };

    const runSearch = async (sourceUrl) => {
      const query = input.value.trim();

      if (!query) {
        restoreCatalogue();
        return;
      }

      if (searchController) searchController.abort();
      searchController = new AbortController();
      setStatus(loadingText);
      setLoading(true);

      try {
        const response = await fetch(getSearchUrl(sourceUrl), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: searchController.signal,
        });

        if (!response.ok) throw new Error('Search request failed');

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const searchResults = documentFragment.querySelector('[data-b2b-search-results-fragment]');

        if (!searchResults) throw new Error('Search results fragment missing');

        results.innerHTML = searchResults.innerHTML;
        setStatus('');
        bindPaginationLinks();
      } catch (error) {
        if (error.name === 'AbortError') return;
        results.innerHTML = `<div class="b2b-empty">${errorText}</div>`;
        setStatus(errorText);
      } finally {
        setLoading(false);
      }
    };

    const queueSearch = () => {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(() => runSearch(), 320);
    };

    function bindPaginationLinks() {
      results.querySelectorAll('.b2b-catalogue-pagination a[href]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          runSearch(link.href);
        });
      });
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      runSearch();
    });

    input.addEventListener('input', queueSearch);
  });
};

initB2BCatalogueInlineSearch();
